export const filterData = [
  {
    id: 0,
    text: "Filter Products",
    name: "category",
    isSelectedDisabled: true,
    optionsArr: [
      "men's footwear",
      "women's footwear",
      "men's wear",
      "women's wear",
    ],
    optionsMap: {
      "men%27s%20wear": "men's wear",
      "women%27s%20wear": "women's wear",
      "men%27s%20footwear": "men's footwear",
      "women%27s%20footwear": "women's footwear",
    },
    queryValue: {
      "men's footwear": "men footwear",
      "women's footwear": "women footwear",
      "men's wear": "men clothwear",
      "women's wear": "women clothwear",
    },
    default: "category",
  },
  {
    id: 1,
    text: "",
    name: "size",
    isSelectedDisabled: true,
    optionsArr: {
      "men's wear": ["xs", "s", "m", "xl", "xxl", "xxxl"],
      "women's wear": ["xs", "s", "m", "xl", "xxl", "xxxl"],
      "men's footwear": ["4", "5", "6", "7", "8", "9", "10", "11"],
      "women's footwear": ["4", "5", "6", "7", "8", "9", "10", "11"],
    },

    optionsMap: {
      "men's wear": {
        xs: "xs",
        s: "s",
        m: "m",
        xl: "xl",
        xxl: "xxl",
        xxxl: "xxxl",
      },
      "women's wear": {
        xs: "xs",
        s: "s",
        m: "m",
        xl: "xl",
        xxl: "xxl",
        xxxl: "xxxl",
      },
      "men's footwear": {
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
      },
      "women's footwear": {
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
      },
    },
    default: "size",
  },
  {
    id: 1,
    text: "Sort",
    name: "sort",
    isSelectedDisabled: false,
    optionsArr: ["price (ascending)", "price (dscending)"],
    optionsMap: {
      "price%20(ascending)": "price (ascending)",
      "price%20(dscending)": "price (dscending)",
    },
    default: "newest",
  },
];
